// Root types

import { ToggleGroupVariant } from "../../components/ToggleGroup/ToggleGroupRoot";

export type ToggleGroupRootBaseStyle = {
  borderColor?: string;
};

export type ToggleGroupRootStateStyle = Partial<
  Record<"disabled" | "focusVisible" | "invalid", ToggleGroupRootBaseStyle>
>;

export type ToggleGroupRootStyle = ToggleGroupRootBaseStyle &
  ToggleGroupRootStateStyle;

// Item types

export type ToggleGroupItemBaseStyle = {
  backgroundColor?: string;
  color?: string;
};

export type ToggleGroupItemStateStyle = Partial<
  Record<
    "checked" | "disabled" | "hover" | "invalid" | "pressed",
    ToggleGroupItemBaseStyle
  > & {
    disabled: { checked?: ToggleGroupItemBaseStyle };
    invalid: { checked?: ToggleGroupItemBaseStyle };
  }
>;

export type ToggleGroupItemStyle = ToggleGroupItemBaseStyle &
  ToggleGroupItemStateStyle;

// Combined types

export type ToggleGroupStyle = {
  item: ToggleGroupItemStyle;
  root: ToggleGroupRootStyle;
};

export type ToggleGroupThemeDefaultProps = {
  variant?: ToggleGroupVariant;
};

export type ToggleGroupTheme = {
  current?: ToggleGroupStyle;
  defaultProps?: ToggleGroupThemeDefaultProps;
  defaultStyle?: ToggleGroupStyle;
  variant?: Partial<Record<ToggleGroupVariant, ToggleGroupStyle>>;
};

export const defaultToggleGroupTheme: ToggleGroupTheme = {
  defaultProps: {
    variant: "secondary",
  },
  defaultStyle: {
    item: {
      backgroundColor: "transparent",
      color: "--black",

      checked: {
        color: "--white",
      },

      disabled: {
        color: "--neutral-a32",

        checked: {
          backgroundColor: "--neutral",
        },
      },

      hover: {
        backgroundColor: "--neutral-400",
      },

      invalid: {
        checked: {
          backgroundColor: "--danger",
        },
      },

      pressed: {
        backgroundColor: "--neutral",
      },
    },
    root: {
      borderColor: "--neutral-400",

      focusVisible: {
        borderColor: "--accent",
      },

      invalid: {
        borderColor: "--danger",
      },
    },
  },
  variant: {
    primary: {
      item: {
        checked: {
          backgroundColor: "--primary",
        },
      },
      root: {},
    },
    secondary: {
      item: {
        checked: {
          backgroundColor: "--black",
        },
      },
      root: {},
    },
  },
};
